import { backend, domain } from 'modules/data';
import { useGetAuditReportDetails } from 'shared/data/webApp/v1';
import { ContentSplitViewMode } from 'shared/states';

import { UseAuditReportStatus } from './useAuditReportStatus.types';

export const useAuditReportStatus = ({
    mode,
    requestId,
    companyId,
}: UseAuditReportStatus): domain.RequestAuditReportStatus => {
    const enabled = mode === ContentSplitViewMode.AuditReport;

    const data = useGetAuditReportDetails({ query: { requestId, companyId } }, { enabled }).data;

    if (!data) {
        return domain.RequestAuditReportStatus.Unknown;
    }

    if (
        data.status === backend.RequestAuditReportsRequestAuditReportStatus.Ok &&
        data.state === backend.RequestAuditReportsRequestAuditReportState.Complete
    ) {
        return domain.RequestAuditReportStatus.Ready;
    }

    return data.status === backend.RequestAuditReportsRequestAuditReportStatus.Error
        ? domain.RequestAuditReportStatus.Error
        : domain.RequestAuditReportStatus.Pending;
};
